import * as React from 'react';
import { Text } from '..';
import { classes } from './PimpleWiringExample.st.css';

export const PimpleWiringExample = () => {
  return (
    <>
      <Text className={classes.smallPimple}>Updated 3 hours ago</Text>
      <br />
      <Text className={classes.largePimple}>Updated 3 hours ago</Text>
    </>
  );
};
